import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Setting from '../components/Setting';
import Heading from '../components/Heading';
import ProfileForm from '../components/SettingComponents/ProfileForm';

const Profile = () => {
    return (
        <div className='SettingsPage Dashboard mt-4'>
            <Container>
                <Row>
                    <Col xs={12}>
                        <Heading heading="Settings" subheading="Here you can manage all your profile" />
                    </Col>

                    <Col xs={12} md={4} lg={3}>
                        <div className='bg-light radius-20 w-100 mt-3 p-4'>
                            <Setting />
                        </div>
                    </Col>

                    <Col xs={12} md={8} lg={9}>
                        <ProfileForm/>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Profile;
